const viewHrisImportRoute = ({ hrisImportId }) => {
  return `/management_panel/user_changes?hris_import_id=${hrisImportId}`
}

export { viewHrisImportRoute }
